<template>
  <v-container>
    <v-snackbar> </v-snackbar>
    <v-card justify="center">
      <!-- <v-card-title>Take a Photo</v-card-title> -->
      <v-card-text>
        <v-row>
          <v-btn @click="toggleCamera">Close Camera</v-btn>
        </v-row>
        <v-row v-if="isCameraOpen">
          <v-container v-if="isCameraOpen" class="camera-box">
            <video
              v-show="!isPhotoTaken"
              ref="camera"
              class="camera-preview"
              :width="previewWidth"
              :height="previewHeight"
              autoplay
            ></video>
            <canvas
              v-show="isPhotoTaken"
              ref="previewCanvas"
              class="camera-preview"
              :width="previewWidth"
              :height="previewHeight"
            ></canvas>
            <canvas
              ref="fullSizeCanvas"
              :width="scaledWidth"
              :height="scaledHeight"
              hidden
            ></canvas>
          </v-container>
        </v-row>
        <v-row v-if="isCameraOpen">
          <div v-if="!isPhotoTaken">
            <v-btn @click="takePhoto">Take Photo</v-btn>
          </div>
          <div v-else>
            <v-btn @click="takePhoto">Discard Photo</v-btn>
          </div>
          <div v-if="isPhotoTaken">
            <v-btn @click="acceptPhoto">Accept Photo</v-btn>
            <v-checkbox v-model="downloadChecked">
              <v-icon @click="downloadChecked = !downloadChecked"
                >mdi-download</v-icon
              >
            </v-checkbox>
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import support from "../plugins/support";

export default {
  name: "TakePhoto",
  components: {},
  data: () => ({
    // isCameraOpen: false,
    isPhotoTaken: false,
    isShotPhoto: false,
    isLoading: false,
    photoData: null,
    isAccepted: false,
    downloadChecked: false,
    scaledWidth: 1200, //assuming landscape
    scaledHeight: 900,
  }),
  props: {
    autoDownload: Boolean,
    previewHeight: Number,
    previewWidth: Number,
    maxheight: Number,
    maxwidth: Number,
    isCameraOpen: Boolean,
  },
  async mounted() {
    //support.checkTabletDbLoginStatus();
    this.createCameraElement();
  },
  computed: {},
  methods: {
    toggleCamera() {
      if (this.isCameraOpen) {
        //this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        try {
          this.stopCameraStream();
        } catch (err) {
          console.log("camera error");
        }
        this.$emit("cameraClose");
      } else {
        //this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: { facingMode: "environment" },
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          if (!this.$refs.camera) {
            // The camera view was closed while permission/setup was pending.
            stream.getTracks().forEach((track) => track.stop());
            return;
          }
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          this.isLoading = false;
          alert(error);
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },

    acceptPhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;
        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
        this.photoFilename;
      }
      // Use the shared compression logic to ensure file size is under 0.25 MB
      const compressedDataUrl = support.compressImage(this.$refs.fullSizeCanvas);

      this.photoData = compressedDataUrl.replace(
        "image/jpeg",
        "image/octet-stream"
      );
      this.$emit("photoAccepted", {
        photo_file_name: this.photoFilename,
        data: this.photoData.replace("data:image/octet-stream;base64,", ""),
      });

      this.isPhotoTaken = false;
      this.isShotPhoto = false;
      this.toggleCamera();
      //this.$emit("cameraClose");
      // if (this.autoDownload) {
      //   this.downloadPhoto();
      // }
    },
    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;
        const FLASH_TIMEOUT = 50;
        this.setFileName();
        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      if (this.isPhotoTaken) {
        const previewContext = this.$refs.previewCanvas.getContext("2d");
        previewContext.drawImage(
          this.$refs.camera,
          0,
          0,
          this.previewWidth,
          this.previewHeight
        );
        let img_width = this.$refs.camera.width; //actual photo width
        let img_height = this.$refs.camera.height;
        let canvas = this.$refs.fullSizeCanvas;
        const fullSizeContext = this.$refs.fullSizeCanvas.getContext("2d");

        fullSizeContext.clearRect(0, 0, canvas.width, canvas.height);
        if (img_width > img_height) {
          canvas.width = this.scaledWidth;
          canvas.height = this.scaledHeight;
          //Draw the image to a new size
          fullSizeContext.drawImage(
            this.$refs.camera,
            0,
            0,
            this.scaledWidth,
            this.scaledHeight
          );
        } else {
          //flipped for portrait
          canvas.width = this.scaledHeight;
          canvas.height = this.scaledWidth;
          //Draw the image to a new size
          fullSizeContext.drawImage(
            this.$refs.camera,
            0,
            0,
            this.scaledHeight,
            this.scaledWidth
          );
        }
      } else {
        this.photoData = null;
      }
      this.$emit("photoTaken", {
        photo_file_name: this.photoFilename,
        data: this.photoData,
      });
    },
    setFileName() {
      const d = new Date();
      this.photoFilename = `${this.$store.getters["shared/dbName"]}_${
        this.$store.getters["shared/tabletCode"]
      }_${support
        .getLocalTimestamp(d)
        .replace(/ /g, "T")
        .replace(/:/g, "")}.jpeg`;
    },

    // downloadPhoto() {
    //   const link = document.createElement("a");
    //   link.href = this.iphotoData;
    //   link.download = this.photoFilename;
    //   link.click();
    // },
  },
};
</script>

<style scoped>
.camera-box {
  max-width: 100%;
}
.camera-preview {
  max-width: 100%;
  height: auto;
}
</style>
